import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

export type MESSAGE_TYPE =
  'NO_CONTENT'
  | 'NOT_SUPPORTED'
  | 'SOMETHING_WRONG'
  | 'CONFLICT'
  | 'FORBIDDEN'
  | 'ERROR'
  | 'TIMEOUT'
  | 'SEARCH'
  | 'NO_SEARCH_RESULTS'
  | 'UNDER_CONSTRUCTION'
  | 'BLOCKING_ERROR'
  | 'NO_ACCESS'
  | 'WORKING_ON_IT'
  | 'USE_QR_CODE_TO_LOGIN'
  | 'TIME_OUT'
  | 'TIME_OUT_ALT'
  | 'SECOND_FACTOR_AUTHENTICATION'
  | 'PASSWORD_RESET'
  | 'NO_INTERNET_CONNECTION'
  | 'NO_DATA'
  | 'CONTRACT_STILL_ACTIVE'
  | 'ACCOUNT_CREATED'
  | 'NOT_FOUND'
  | 'NOT_FOUND_ALT';

@Component({
  selector: 'gp-illustrated-message',
  template: `
    <div class="noContent">
      <ng-container [ngSwitch]="type">
        <img src="assets/images/illustration_state_no_data2.svg" alt="no content"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NO_CONTENT'"/>
        <img src="assets/images/illustration_state_no_access.svg" alt="no content"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NO_ACCESS'"/>
        <img src="assets/images/illustration_state_not_supported.svg" alt="not supported"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NOT_SUPPORTED'"/>
        <img src="assets/images/illustration_state_error2.svg" alt="something went wrong"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'SOMETHING_WRONG'"/>
        <img src="assets/images/illustration_state_error1.svg" alt="Conflict"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'CONFLICT'"/>
        <img src="assets/images/illustration_state_error1.svg" alt="Error"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'ERROR'"/>
        <img src="assets/images/illustration_state_error1.svg" alt="BLOCKING_ERROR"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'BLOCKING_ERROR'"/>
        <img src="assets/images/illustration_state_error1.svg" alt="Forbidden"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'FORBIDDEN'"/>
        <img src="assets/images/illustration_state_error1.svg" alt="Timeout"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'TIMEOUT'"/>
        <img src="assets/images/illustration_state_searching.svg" alt="Search"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'SEARCH'"/>
        <img src="assets/images/illustration_state_no_search_results_01.svg" alt="no search results"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NO_SEARCH_RESULTS'"/>
        <img src="assets/images/illustration_state_under_construction.svg" alt="under construction"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'UNDER_CONSTRUCTION'"/>
        <img src="assets/images/illustration_state_working_on_it_02.svg" alt="working on it"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'WORKING_ON_IT'"/>
        <img src="assets/images/illustration_state_use_qr_code_to_login.svg" alt="use QR code to login"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'USE_QR_CODE_TO_LOGIN'"/>
        <img src="assets/images/illustration_state_time_out_01.svg" alt="time out"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'TIME_OUT'"/>
        <img src="assets/images/illustration_state_time_out_02.svg" alt="time out"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'TIME_OUT_ALT'"/>
        <img src="assets/images/illustration_state_second_factor_authentication.svg" alt="second factor authentication"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'SECOND_FACTOR_AUTHENTICATION'"/>
        <img src="assets/images/illustration_state_password_reset.svg" alt="password reset"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'PASSWORD_RESET'"/>
        <img src="assets/images/illustration_state_no_internet_connection_01.svg" alt="no internet connection"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NO_INTERNET_CONNECTION'"/>
        <img src="assets/images/illustration_state_no_data1.svg" alt="no data"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NO_DATA'"/>
        <img src="assets/images/illustration_state_contract_still_active_01.svg" alt="contract still active"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'CONTRACT_STILL_ACTIVE'"/>
        <img src="assets/images/illustration_state_account_created.svg" alt="account created"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'ACCOUNT_CREATED'"/>
        <img src="assets/images/illustration_state_404_01.svg" alt="not found"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NOT_FOUND'"/>
        <img src="assets/images/illustration_state_404_02.svg" alt="not found"
             [ngStyle]="{'width': this.width, 'height': 'auto'}"
             *ngSwitchCase="'NOT_FOUND_ALT'"/>
      </ng-container>
      <h4 class="font-weight-bold">{{ text | translate:{key: key} }}</h4>
      <h6 class="text-muted font-weight-normal" *ngIf="subText">{{ subText | translate }}</h6>
      <p class="text-muted font-weight-normal" *ngIf="hintText">{{ hintText | translate }}</p>
    </div>`,
  styleUrls: ['./illustrated-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IllustratedMessageComponent {
  @Input()
  public text: string;
  @Input()
  public key: string;
  @Input()
  public subText: string;
  @Input()
  public hintText: string;
  @Input()
  public type: MESSAGE_TYPE = 'NO_CONTENT';
  @Input()
  public width: string = 'auto';
}
